module.exports = __webpack_public_path__ + "static/media/24UHCHR9.82d9cd75.jpg";